import React, { forwardRef } from 'react';
import { Input, InputProps } from 'antd';
import SvgIconSearch from '../@svg/SvgSearch';
import './index.scss';
import SvgIconClose from '../@svg/SvgClose';

const CustomSearchInput = forwardRef((props: InputProps, ref: any) => {
  const { ...restProps } = props;

  return (
    <Input
      ref={ref}
      prefix={<SvgIconSearch />}
      allowClear={{ clearIcon: <SvgIconClose /> }}
      {...restProps}
      placeholder={restProps?.placeholder ? restProps.placeholder : ''}
      className={`ant-custom-search-input ${restProps.className}`}
    />
  );
});

export default CustomSearchInput;
